import React from "react"
import { FormattedDate, FormattedMessage, FormattedNumber } from "react-intl"
import { Link } from "react-router-dom"
import SortLink from "../../common/listing/sortlink.component.jsx"
import { Intl } from "../../state/helpers/IntlProps"
import { ADJUSTMENT_MESSAGES } from "./messages"


const headerKeys = [
    "createdAt",
    "quantity",
    "document",
    "description",
]

export const getHeadersData = (
    sortByField: string,
    sortAsc: boolean,
    handleSortLinkChange: (sortByField: string, sortAsc: boolean) => void,
    intl: Intl
) => {
    return headerKeys.map(key => {
        return <SortLink
            key={key}
            field={key}
            sortField={sortByField}
            asc={sortAsc}
            onChange={handleSortLinkChange}
        >
            {intl.formatMessage(ADJUSTMENT_MESSAGES[`header_${key}`])}
        </SortLink>
    })
}


export const getRowCellsData = (adjustment) => {
    const url = adjustment.documentType ? `/${adjustment.documentType}/${adjustment.documentId}/edit` :
        `/inventory/imports/${adjustment.importId}/edit`

    return [
        <FormattedDate
            key={`${adjustment.id}-createdAt`}
            year="numeric"
            month="long"
            day="numeric"
            value={new Date(adjustment.createdAt)}
        />,
        <>
            {Number(adjustment.quantity) && Number(adjustment.quantity) > 0 && "+"}
            <FormattedNumber
                key={`${adjustment.id}-quantity`}
                value={new Number(adjustment.quantity)}
            />
        </>,
        <Link to={url} key={`${adjustment.id}-documentIdentifier`}>
            {adjustment.documentIdentifier ? adjustment.documentIdentifier : adjustment.documentId}
        </Link>,
        listingAction[adjustment.action]
    ]
}

const listingAction = {
    "import-created": (
        <FormattedMessage
            id="inventory.adjustment_listing.import_created"
            defaultMessage="Import created"
        />
    ),
    "invoice-sent" : (
        <FormattedMessage
            id="inventory.adjustment_listing.invoice_sent"
            defaultMessage="Invoice sent"
        />
    ),
    "invoice-returned" : (
        <FormattedMessage
            id="inventory.adjustment_listing.invoice_returned"
            defaultMessage="Invoice returned"
        />
    ),
    "invoice-voided" : (
        <FormattedMessage
            id="inventory.adjustment_listing.invoice_voided"
            defaultMessage="Invoice voided"
        />
    ),
    "invoice-archived" : (
        <FormattedMessage
            id="inventory.adjustment_listing.invoice_deleted"
            defaultMessage="Invoice deleted"
        />
    ),
    "invoice-unarchived" : (
        <FormattedMessage
            id="inventory.adjustment_listing.invoice_unarchived"
            defaultMessage="Invoice unarchived"
        />
    ),
    "order-sent" : (
        <FormattedMessage
            id="inventory.adjustment_listing.order_sent"
            defaultMessage="Order sent"
        />
    ),
    "order-unarchived" : (
        <FormattedMessage
            id="inventory.adjustment_listing.order_unarchived"
            defaultMessage="Order unarchived"
        />
    ),
    "order-line-updated" : (
        <FormattedMessage
            id="inventory.adjustment_listing.order_line_updated"
            defaultMessage="Order line updated"
        />
    ),
    "order-line-created" : (
        <FormattedMessage
            id="inventory.adjustment_listing.order_line_created"
            defaultMessage="Order line created"
        />
    ),
    "order-line-deleted" : (
        <FormattedMessage
            id="inventory.adjustment_listing.order_line_deleted"
            defaultMessage="Order line deleted"
        />
    ),
    "stock-document-in-process" : (
        <FormattedMessage
            id="inventory.adjustment_listing.stock_document_in_process"
            defaultMessage="Stock document in process"
        />
    ),
    "stock-document-completed" : (
        <FormattedMessage
            id="inventory.adjustment_listing.stock_document_completed"
            defaultMessage="Stock document completed"
        />
    ),
    "stock-document-items-sent" : (
        <FormattedMessage
            id="inventory.adjustment_listing.stock_document_items_sent"
            defaultMessage="Items sent"
        />
    ),
    "stock-document-items-received" : (
        <FormattedMessage
            id="inventory.adjustment_listing.stock_document_items_received"
            defaultMessage="Items received"
        />
    ),
}




// WEBPACK FOOTER //
// ./src/utils/inventory/adjustmentListingHelper.tsx